import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Header from "../components/header";

import { doLoginRequest, doRegisterRequest } from "../state/actions";
import RecoverMessage from "../components/recoverMessage";

class RecoverMessageSuccess extends Component {
  render() {
    return (
      <Fragment>
        <Header showSubTitle="true" />
        <RecoverMessage />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.account
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      doRegisterRequest,
      doLoginRequest
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(RecoverMessageSuccess));

Routered.displayName = "RecoverMessageSuccess";

export default Routered;
